import { render, staticRenderFns } from "./PreviewCandidateSidebar.vue?vue&type=template&id=af4cc8e6&"
import script from "./PreviewCandidateSidebar.vue?vue&type=script&lang=js&"
export * from "./PreviewCandidateSidebar.vue?vue&type=script&lang=js&"
import style0 from "./PreviewCandidateSidebar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports